import type { IconData } from '@stacksjs/iconify-core'

export const recycleBin2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M6.182 15.842c.887 13.815 1.736 21.002 2.24 24.423c.256 1.73 1.392 3.14 3.093 3.548C13.83 44.37 17.817 45 24.002 45s10.171-.63 12.487-1.186c1.7-.408 2.836-1.818 3.092-3.548c.505-3.422 1.353-10.609 2.24-24.427\"/><path d=\"M31.036 7.176c3.56.066 6.334.174 8.322.275c2.39.12 4.61 1.393 5.278 3.691q.152.517.276 1.097c.394 1.84-.983 3.421-2.858 3.58c-3.02.255-8.547.545-18.077.545c-9.529 0-15.057-.29-18.076-.545c-1.876-.158-3.261-1.75-2.776-3.568c.175-.655.39-1.253.616-1.784c.813-1.903 2.77-2.885 4.836-2.999c1.908-.104 4.685-.222 8.387-.292A7 7 0 0 1 23.37 3h1.262a7 7 0 0 1 6.405 4.176ZM18 25l1 10m11-10l-1 10\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default recycleBin2
